<template>
  <div v-if="isVisible" class="welcome-modal">
    <div class="welcome-modal-wrapper">
      <img :src="modalData.bgImage" alt="Message Bg" class="modal-bg-image" />
      <div class="welcome-modal-content">
        <img :src="modalData.charImage" alt="Message Character" class="modal-char-image" />
        <div class="welcome-modal-content-text">
          <h3 class="welcome-modal-sub-title">{{ modalData.subTitle }}</h3>
          <p class="welcome-modal-description">{{ modalData.description }}</p>
          <button @click="handleButtonClick" class="welcome-modal-btn">Click in now</button>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import { defineComponent } from "vue"; 
  
  export default defineComponent({
    name: 'UpgradeMessageModal',
    props: {
    isVisible: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return{
        
        modalData:{
          title: "",
          subTitle: "You can find your Upgrade just here!",
          description:
            "Not made a purchase yet? You can check out what we can offer you in our custom store. Not sure what products we offer? Check out or store and find out more about our amazing upgrades.",
          bgImage: require("@/assets/characters/message_modal_bg.png"),
          charImage: require("@/assets/characters/message_modal_char.png")
        }
      }
    },
    methods: {
      handleButtonClick() {
        this.$emit("update:isVisible", false);
        window.location.href ="/store"; 
      }
    },
  });
</script>
<style lang="scss" scoped>
  .welcome-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: rgba(27, 27, 27, 0.5);
    z-index:1001;
    &-wrapper{
      max-width:870px;
      width:100%;
      background: #fff;
      border-radius: 26px;
      text-align: center;
      box-shadow: 0px 6px 8px 0px rgba(232, 232, 232, 0.25);
      overflow: auto;
      display:grid;
    }
    &-content{
      grid-column: 1 / -1;
      grid-row: 1 / -1;
      position: relative;
      align-items: center;
      z-index: 1;
      @media screen and (min-width:768px){
        display: flex;
      }
      &-text{
        padding: 20px 30px 30px;
        @media screen and (min-width:768px){
          padding: 0 50px 0 0;
        }
      }
    }
    .modal-char-image{
      max-height: 200px;
      @media screen and (min-width:768px){
        max-height: initial;
      }
    }
    &-sub-title{
      font:600 18px/27px "Poppins";
      background: linear-gradient(90deg, #933C6E 0%, #EEA600 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }
    &-description{
      font:600 12px/27px "Poppins";
    }
    &-btn{
      background: #1A3B84;
      color: #fff;
      padding: 12px 30px;
      border-radius: 26px;
      font:500 14px/1.4 "Poppins";
      appearance: none;
      box-shadow: none;
      border: none;
      @media screen and (min-width:992px){
        min-width:350px;
      }
    }
    .modal-bg-image{
      max-width: 100%;
      grid-column: 1 / -1;
      grid-row: 1 / -1;
    }
  }
</style>